import { render, staticRenderFns } from "./LetrangerArticle.vue?vue&type=template&id=17493034&"
import script from "./LetrangerArticle.vue?vue&type=script&lang=js&"
export * from "./LetrangerArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports